// @flow
import React from "react";
import { NumberField } from "@quantum/ui";
import { Translate } from "@quantum/i18n";
import { connect } from "react-redux";
import {
  type ActionCreator,
  editarHorizonteDu,
  getHorizonteDuSelecionado,
} from "../../../../state";
import { VALOR_DEFAULT_HORIZONTE_DU } from "../../../../model";

type Prop = {
  horizonte: number,
  editarHorizonteDu: ActionCreator,
  className?: ?string,
};

function SelecaoHorizonteDu({ horizonte, editarHorizonteDu, className }: Prop) {
  function handleHorizonteDuEditado(horizonte) {
    editarHorizonteDu(horizonte);
  }

  function onBlur() {
    if (horizonte !== 0 && !horizonte) {
      editarHorizonteDu(VALOR_DEFAULT_HORIZONTE_DU);
    }
  }

  return (
    <div>
      <Translate className="ConfiguracaoMedida__label--no-margin">
        Comum.Horizonte
      </Translate>
      <NumberField
        className={className}
        allowNegative={false}
        onlyInteger={true}
        max={1000}
        min={1}
        onChangeValue={handleHorizonteDuEditado}
        value={horizonte}
        thousandSeparator={""}
        onBlur={onBlur}
      />
    </div>
  );
}

export default connect(
  state => ({
    horizonte: getHorizonteDuSelecionado(state),
  }),
  { editarHorizonteDu }
)(SelecaoHorizonteDu);
